@if (progressProducts.length > 0) {
    <adapt-universal-dashboard-element name="Journey progress"
                                       [url]="url$ | async">
        <adapt-progress-bar class="progress-bar"
                            [percentageProgress]="progressPercent"
                            [adaptTooltip]="progressText"
                            [adaptTooltipIsHtml]="true"
                            [colour]="ProgressItemStatusMeta[ProgressItemStatus.Done].colour"></adapt-progress-bar>
    </adapt-universal-dashboard-element>
}
